<div class="theme-picker" (click)="onPanelClick($event)">
  <button
    type="button"
    class="icon-btn theme-mode-btn"
    (click)="toggleDark($event)"
    [attr.aria-label]="themeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
    [title]="themeService.isDark() ? 'Light mode' : 'Dark mode'">
    <span class="pi" [class.pi-sun]="themeService.isDark()" [class.pi-moon]="!themeService.isDark()"></span>
  </button>

  <button
    type="button"
    class="icon-btn theme-picker-btn"
    (click)="toggle($event)"
    [attr.aria-expanded]="open"
    aria-label="Color theme"
    title="Color theme">
    <span class="pi pi-palette"></span>
    <span class="theme-picker-dot" [style.background]="themeService.getSelectedPalette().primary"></span>
  </button>

  @if (open) {
    <div class="theme-picker-panel" role="dialog" aria-label="Choose color theme">
      <p class="theme-picker-title">Color theme</p>
      <div class="theme-picker-grid">
        @for (palette of themeService.palettes; track palette.id) {
          <button
            type="button"
            class="theme-swatch"
            [class.is-active]="themeService.selectedPaletteId() === palette.id"
            (click)="selectPalette(palette.id, $event)"
            [attr.aria-label]="palette.name"
            [title]="palette.name">
            <span class="theme-swatch-color" [style.background]="palette.primary"></span>
            <span class="theme-swatch-label">{{ palette.name }}</span>
            @if (themeService.selectedPaletteId() === palette.id) {
              <span class="pi pi-check theme-swatch-check"></span>
            }
          </button>
        }
      </div>
    </div>
  }
</div>
